import { updateSessionInfo } from '@/shared/lib/auth/session-storage';

const state = {
    userInfo: null,
    historyDates: null,
};
const getters = {
    USER_INFO: state => state.userInfo,
    HISTORY_DATES: state => state.historyDates,
};
const mutations = {
    SET_USERINFO: (state, payload) => {
        state.userInfo = payload;
    },
    SET_ORDERS_HISTORY_DATES: (state, data) => {
        state.historyDates = data;
    },
};
const actions = {
    GET_USERINFO({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios({ url: '/api/auth/user', method: 'GET', })
                .then(resp => {
                    const list = resp.data.data
                    commit('SET_USERINFO', list)

                    // Sync with authorization store and the stored session record
                    updateSessionInfo(list);
                    commit('SET_USER_INFO', list, { root: true });

                    resolve(resp)
                })
                .catch(err => {
                    dispatch('LOGOUT');
                    reject(err)
                })
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
